import { useState, type InputHTMLAttributes } from 'react';
import { Icon } from './Icon';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

/**
 * Campo de texto. Mesma API do `Input` do `enamed-feedback-lp`, com a forma em
 * `.field` (`styles/lp.css`) para as cores seguirem o tema do tenant.
 */
export function Input({
  label,
  error,
  helperText,
  className = '',
  id,
  type,
  ...props
}: InputProps) {
  const isPassword = type === 'password';
  const [isRevealed, setIsRevealed] = useState(false);

  return (
    <div className="field">
      {label && (
        <label htmlFor={id} className="field-label">
          {label}
        </label>
      )}

      <div className="field-control">
        <input
          id={id}
          type={isPassword && isRevealed ? 'text' : type}
          className={`field-input ${isPassword ? 'has-action' : ''} ${className}`}
          aria-invalid={!!error}
          aria-describedby={error && id ? `${id}-error` : undefined}
          {...props}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setIsRevealed((revealed) => !revealed)}
            aria-label={isRevealed ? 'Ocultar senha' : 'Mostrar senha'}
            className="field-action"
          >
            <Icon size="sm">
              {isRevealed ? (
                <>
                  <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                  <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                  <path d="M6.61 6.61A13.53 13.53 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                  <path d="m2 2 20 20" />
                </>
              ) : (
                <>
                  <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                  <circle cx="12" cy="12" r="3" />
                </>
              )}
            </Icon>
          </button>
        )}
      </div>

      {error && (
        <p id={id ? `${id}-error` : undefined} className="field-error">
          {error}
        </p>
      )}
      {helperText && !error && <p className="field-help">{helperText}</p>}
    </div>
  );
}
